export default __webpack_public_path__ + "static/media/add.9984c933.svg";